var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: { visible: true, title: "New Message" },
          on: { close: _vm.onFormClose },
        },
        [
          _vm.isBusy ? _c("loading") : _vm._e(),
          _vm._v(" "),
          !_vm.isBusy
            ? _c(_vm.currentComponent, {
                tag: "component",
                attrs: {
                  "contact-search-url": _vm.contactSearchUrl,
                  "store-url": _vm.storeQuickMessageUrl,
                  "outgoing-numbers": _vm.outgoingNumbers,
                },
                on: {
                  created: _vm.onMessageCreated,
                  "change-mode": _vm.onChangeMode,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }